import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import removeAccents from 'remove-accents';
import {Icon} from 'front-onceforall-core';
import TextField from '@material-ui/core/TextField';

import {getDocumentsByCountry} from '../../utils/document';

import DocumentListEdit from '../DocumentListEdit';

function DocumentListSearch(props) {
  const [searchFilter, setSearchFilter] = React.useState('');
  const [filteredDocuments, setFilteredDocuments] = React.useState(props.documents);

  function filterDocuments() {
    let filteredDocs = getDocumentsByCountry(props.documents, props.dossierCountry);

    if (searchFilter.length > 0) {
      const searchFilterNormalized = removeAccents(searchFilter.toLowerCase());
      filteredDocs = filteredDocs.filter(document => removeAccents(document.type.name.toLowerCase()).indexOf(searchFilterNormalized) !== -1);
    }

    setFilteredDocuments(filteredDocs);
    props.onFilterDocuments?.(filteredDocs);
  }

  function handleSearchChange(event) {
    setSearchFilter(event.target.value);
  }

  React.useEffect(filterDocuments, [props.documents, props.dossierCountry, searchFilter]);

  return <>
    <div className="card inline-container col-12">
      <TextField
        data-id="document-search-field"
        label={<div className="inline-container">
          <Icon icon="mag-glass"/>
          <Translate value="document.searchBar"/>
        </div>}
        value={searchFilter}
        onChange={handleSearchChange}
        disabled={props.loading}
      />
    </div>
    <DocumentListEdit
      organisationId={props.organisationId}
      documents={filteredDocuments}
      onRefreshDocuments={props.onRefreshDocuments}
      depositor={props.depositor}
      loading={props.loading}
    />
    {filteredDocuments.length < 1 &&
      <div className="table-without-result">
        <Translate value="document.noResultMatch"/>
      </div>
    }
  </>;
}

DocumentListSearch.propTypes = {
  documents: PropTypes.array.isRequired,
  dossierCountry: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  organisationId: PropTypes.number.isRequired,
  onRefreshDocuments: PropTypes.func.isRequired,
  onFilterDocuments: PropTypes.func,
  depositor: PropTypes.bool.isRequired
};

export default DocumentListSearch;
